import { render, staticRenderFns } from "./EDrawerListarMatriculas.vue?vue&type=template&id=cff308b6&scoped=true"
import script from "./EDrawerListarMatriculas.vue?vue&type=script&lang=js"
export * from "./EDrawerListarMatriculas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff308b6",
  null
  
)

export default component.exports